module.exports = __webpack_public_path__ + "img/calendar2.04afb257.png";